exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-tree[data-v-67e40aea]{height:500px;width:450px;border-radius:4px;z-index:999;border:none;top:45px;left:0}.model-tree[data-v-67e40aea] .el-tree{height:calc(100% - 72px);overflow-y:auto}[data-v-67e40aea] .el-card{height:calc(100% - 24px)!important}[data-v-67e40aea] .el-card__body{padding:10px!important;border-radius:2px}.card-footer[data-v-67e40aea]{border:none!important;bottom:34px;right:10px}", ""]);

// exports
